import { useEffect, useRef, useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';

export default function MobileRow({ row }: any) {
  const [open, setOpen] = useState<boolean>(true);
  const sidebarRef = useRef<HTMLElement | null>();

  // Event handler to close the sidebar if clicked outside
  const handleClickOutside = (event: any) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <div className="border-gray-300 border-2 rounded-md shadow-sm mb-2">
      <div className="border-gray-300 border-b-2 flex justify-between">
        <div className="p-2">
          <span className="text-xs text-gray-500">Parcel ID</span>
          <br />
          <span>{row.id}</span>
        </div>

        <div className="bg-[#3f51b5] p-3 text-xl rounded-r-sm text-white relative">
          <div
            onClick={() => {
              if (row.status === 'BOOKING') {
                window.open(`/dashboard/parcel/edit/${row.id}`);
              } else {
                window.open(`/dashboard/parcel/view/${row.id}`);
              }
            }}
          >
            {row.status === 'BOOKING' ? <EditIcon /> : <DocumentScannerIcon />}
          </div>

          {/* <div
            onClick={() => {
              setOpen(true);
            }}
          >
            &hellip;
          </div>

          <div
            ref={sidebarRef as RefObject<HTMLDivElement>}
            className={`absolute right-0 bg-gray-200 text-black text-sm rounded-sm transition-all duration-500 ease-in-out ${
              open ? 'max-h-48' : 'max-h-0 overflow-hidden'
            }`}
          >
            <div className="p-2 hover:bg-gray-300">Edit</div>
            <div className="p-2 hover:bg-gray-300">Delete</div>
          </div> */}
        </div>
      </div>
      <div className="p-2">
        <div className="flex justify-between">
          <div className="text-xs text-gray-500">Date</div>
          <div>{row.booking_date}</div>
        </div>
        <div className="flex justify-between">
          <div className="text-xs text-gray-500">Date</div>
          <div className="">
            {row?.payment?.id ? (
              <span className="px-2 py-1 mx-1 text-xs text-white bg-green-500 rounded-full">Paid</span>
            ) : (
              <span className="px-2 py-1 mx-1 text-xs text-white bg-red-500 rounded-full">Unpaid</span>
            )}
            <span className={`px-2 py-1 text-xs rounded-full bg-gray-500  text-white`}>{row.status}</span>
          </div>
        </div>
        <div className="flex justify-between">
          <div className="text-xs text-gray-500">Invoice</div>
          <div>{row.memoNo}</div>
        </div>
        <div className="flex justify-between">
          <div className="text-xs text-gray-500">Rider</div>
          <div>{row.rider?.name}</div>
        </div>
        <div className="flex justify-between">
          <div className="text-xs text-gray-500">Customer Info</div>
          <div className="text-right">
            <div>{row.customerName}</div>
            <div>{row.phoneNumber}</div>
          </div>
        </div>
        {row.address && (
          <div className="flex justify-between">
            <div className="text-xs text-gray-500">Address</div>
            <div>{row.address}</div>
          </div>
        )}
        {row.area?.name && (
          <div className="flex justify-between">
            <div className="text-xs text-gray-500">Area</div>
            <div>{row.area?.name}</div>
          </div>
        )}
        <div className="flex justify-between">
          <div className="text-xs text-gray-500">Weight</div>
          <div>
            {row.weight} {row.weight ? 'Kg.' : ''}
          </div>
        </div>
        <div className="flex justify-between">
          <div className="text-xs">Cash Collection</div>
          <div>{row.COD}</div>
        </div>
        <div className="flex justify-between">
          <div className="text-xs">Charge</div>
          <div>{row.deliveryCharge}</div>
        </div>
        {row.details && (
          <div className="flex justify-between">
            <div className="text-xs">Note</div>
            <div>{row.details}</div>
          </div>
        )}
      </div>
    </div>
  );
}
